import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stbyStripHtml',
})
export class StripHtmlPipe implements PipeTransform {
    transform(value: string): string {
        const withNewlines = value.replace(/<br\s*\/?>/gi, '\n');
        const stripped = withNewlines.replace(/<[^>]*>/g, '');
        return stripped.replace(/\n/g, '<br>');
    }
}
